import React from 'react';
import { Modal } from 'react-bootstrap';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import ModalComponent from '../../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';

function GenericErrorModal(props) {
  const {
    show,
    message,
    setModalJSX,
  } = props;

  const closeErrorModalHandler = () => setModalJSX(<></>);

  return (
    <ModalComponent
      show={show}
      close={closeErrorModalHandler}
      showConfirmCallToAction={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Icon
            icon="triangle-exclamation"
            className="text-danger"
          />
          {' '}
          Error
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
    </ModalComponent>
  );
}

GenericErrorModal.defaultProps = {
  message: 'An error occurred while communicating with the server.',
};

GenericErrorModal.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export { GenericErrorModal };
export default connectModalContainerContextToComponent(GenericErrorModal);
